import React, { Fragment } from "react";
import { toast } from "react-toastify";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { Btn, H5 } from "../../../AbstractElements";
import { BottomCenter, BottomLeft, CustomDirections, RightBottom, TopCenter } from "../../../Constant";

const CustomDirectionsClass = () => {
  const directiontoaster = (toastname) => {
    switch (toastname) {
      case "directionssuccessToast":
        toast.success("Success Notification !", {
          position: "top-center",
        });
        break;
      case "directionsinfoToast":
        toast.info("Info Notification !", {
          position: "bottom-center",
        });
        break;
      case "directionswarningToast":
        toast.warn("Warning Notification !", {
          position: "bottom-left",
        });
        break;
      case "directionsdangerToast":
        toast.error("Danger Notification !", {
          position: "bottom-right",
        });
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <Col sm="12">
        <Card>
          <CardHeader className="pb-0">
            <H5>{CustomDirections}</H5>
          </CardHeader>
          <CardBody>
            <div className="btn-showcase">
              <Btn attrBtn={{ name: "directionssuccessToast", color: "success", onClick: (e) => directiontoaster(e.target.name) }}>{TopCenter}</Btn>
              <Btn attrBtn={{ name: "directionsinfoToast", color: "info", onClick: (e) => directiontoaster(e.target.name) }}> {BottomCenter}</Btn>
              <Btn attrBtn={{ name: "directionswarningToast", color: "warning", onClick: (e) => directiontoaster(e.target.name) }}>{BottomLeft}</Btn>
              <Btn attrBtn={{ name: "directionsdangerToast", color: "danger", onClick: (e) => directiontoaster(e.target.name) }}>{RightBottom}</Btn>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};

export default CustomDirectionsClass;
